import React, { useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import useReactRouter from "use-react-router";
import { useDispatch, useMappedState } from "redux-react-hook";
import {
  Breadcrumb,
  BreadcrumbItem,
  PageSection,
  PageSectionVariants,
  Title,
  TextContent,
  Text,
  TextVariants,
} from "@patternfly/react-core";
import CreateOrEditProductGroup from "../components/productGroup/CreateOrEditProductGroup";
import { REQUESTED_PRODUCT_GROUPS } from "../redux/actions/productGroupAction";

export default () => {
  let productGroup = [];
  const { match } = useReactRouter();

  const mapState = useCallback(
    (state) => ({
      productGroups: state.productGroupState.productGroups,
    }),
    []
  );

  const { productGroups } = useMappedState(mapState);
  const dispatch = useDispatch();

  // fetch productGroups
  useEffect(() => {
    if (!productGroups && match.params.productGroupId) {
      dispatch({
        type: REQUESTED_PRODUCT_GROUPS,
        payload: {},
      });
    }
  }, [dispatch, productGroups, match.params.productGroupId]);

  const formType = match.params.productGroupId ? "Edit" : "Create";

  if (match.params.productGroupId && productGroups) {
    productGroup = productGroups.filter(
      (productGroup) =>
        productGroup.id.toString() === match.params.productGroupId.toString()
    );
  }

  return (
    <>
      <PageSection variant={PageSectionVariants.light}>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/product/list">Product</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/product/group">Product Group</Link>
          </BreadcrumbItem>
          <BreadcrumbItem isActive>{`${formType} Group`}</BreadcrumbItem>
        </Breadcrumb>
        <Title headingLevel="h1" size="4xl" className="pf-c-title--PaddingTop">
          {`${formType} Product Group`}
        </Title>
        <TextContent>
          <Text component={TextVariants.h2}>
            Please edit the product group info here:
          </Text>
        </TextContent>
      </PageSection>
      <PageSection isFilled variant={PageSectionVariants.light}>
        <CreateOrEditProductGroup
          onSubmit={() => {}}
          productGroup={productGroup && productGroup[0]}
        />
      </PageSection>
    </>
  );
};
